<template>
  <div class="fixed bottom-24 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2">
    <transition-group name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="bg-slate-900 text-white px-4 py-3 rounded-xl shadow-2xl flex items-center gap-3 min-w-[200px] animate-fade-in-up"
      >
        <div class="w-5 h-5 rounded-full flex items-center justify-center" :class="bgColors[toast.type]">
          <IconCheck v-if="toast.type === 'success'" class="w-4 h-4" />
          <IconX v-else-if="toast.type === 'error'" class="w-4 h-4" />
          <IconCircleAlert v-else class="w-4 h-4" />
        </div>
        <span class="text-sm font-medium">{{ toast.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { IconCheck, IconX, IconCircleAlert } from '../icons'

export default {
  name: 'AppToast',
  components: {
    IconCheck,
    IconX,
    IconCircleAlert
  },
  props: {
    toasts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bgColors: {
        success: 'bg-green-500',
        error: 'bg-red-500',
        info: 'bg-amber-400'
      }
    }
  },
  watch: {
    toasts: {
      handler(newToasts) {
        newToasts.forEach(toast => {
          setTimeout(() => {
            this.$emit('remove', toast.id)
          }, 2000)
        })
      },
      deep: true
    }
  }
}
</script>
